exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pip-details-panel{background:#fff;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 3px rgba(0,0,0,.24);margin-bottom:20px;padding:18px}.pip-details-panel header{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:1.8rem;margin-bottom:10px}.pip-details-panel .pip-details header{color:#454545}.pip-details-panel .pip-required-items-list{margin:0 20px}.pip-details-panel .pip-required-items{margin-top:20px}.pip-details-panel .pip-required-items h3{font-family:Arial,sans-serif;font-size:1.8rem;margin-bottom:10px}.pip-details-panel .special-instructions{margin-top:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/claim/pip/components/pip-details-panel/index.scss
// module id = 5051
// module chunks = 0